export default __webpack_public_path__ + "media/Veggies-Processed-Vegetables.af7826af.png";